import { PartConfigurationAttributesApi } from "src/api/generated/erp/configurator/api/partConfigurationAttributesApi.ts";
import { AavoForm, AavoFormContentParams } from "src/components/common/forms/AavoForm";
import { ObjectAttributeFieldFormComponent } from "src/components/views/erp/objectAttributes/ObjectAttributeFieldFormComponent.tsx";
import { useFieldArray } from "react-hook-form";
import { AttributeFieldWithValue } from "src/components/views/erp/objectAttributes/AttributeFieldWithValue.tsx";
import { FormCommonProps } from "src/components/common/forms/types.ts";
import { defineAgentUiContextKey } from "src/components/views/ai/assistant/uiContext/agentUiContextKey.ts";
import { ConfigurationManualEditContext } from "src/api/generated/erp/configurator/manualEdit/configurationManualEditContext.ts";

export interface PartConfigurationAttributesFormProps extends FormCommonProps<void> {
	partConfigurationId: number;
	attributes: AttributeFieldWithValue[];
	manualEditContext?: ConfigurationManualEditContext;
}

interface FormValues {
	attributes: AttributeFieldWithValue[];
}

export const PartConfigurationAttributesForm = ({
	partConfigurationId,
	attributes,
	onFormEdited,
	onCompleted,
	manualEditContext,
}: PartConfigurationAttributesFormProps) => {
	return (
		<AavoForm
			defaultValues={{
				attributes: attributes,
			}}
			submit={submitForm}
			columns={2}
			onCompleted={onCompleted}
			onFormEdited={onFormEdited}
			agentContext={{
				key: defineAgentUiContextKey("erp.configurator.partConfigurationAttributes.form"),
				data: {
					partConfigurationId: partConfigurationId,
				},
			}}
			render={(params) => <FormContent {...params} />}
		/>
	);

	async function submitForm(values: FormValues) {
		await PartConfigurationAttributesApi.saveAttributes({
			partConfigurationId: partConfigurationId,
			attributes: values.attributes,
			manualEditContext,
		});
	}
};

const FormContent = ({ control }: AavoFormContentParams<FormValues>) => {
	const attributeFieldArray = useFieldArray({
		control,
		name: "attributes",
	});

	return attributeFieldArray.fields.map((field, index) => {
		return (
			<ObjectAttributeFieldFormComponent
				key={field.id}
				control={control}
				name={`attributes.${index}.attributeValue`}
				fieldDefinition={field}
			/>
		);
	});
};
